import React from "react";
import Sidebar from "react-sidebar";
import connect from "react-redux/es/connect/connect";
import ItemsList from "./Sidebar/ItemsList";

class SidebarMenu extends React.Component {
    render() {
        const {
            user, designers, vault_articles, stores, bc_filter_tree, openLoginModal, sidebarOpen, onSetSidebarOpen,
            openLogoutModal, user_profile, current_tier
        } = this.props;

        return (
            <Sidebar
                sidebar={<ItemsList
                    onSetSidebarOpen={onSetSidebarOpen}
                    user={user}
                    vault_articles={vault_articles}
                    stores={stores}
                    designers={designers}
                    openLoginModal={openLoginModal}
                    openLogoutModal={openLogoutModal}
                    bc_filter_tree={bc_filter_tree}
                    sidebarOpen={sidebarOpen}
                    user_profile={user_profile}
                    current_tier={current_tier}
                />}
                open={sidebarOpen}
                onSetOpen={onSetSidebarOpen}
                sidebarClassName="sidebar-menu-nav"
                styles={{
                    sidebar: {
                        zIndex: 20,
                        position: "absolute",
                        top: 0,
                        bottom: 0,
                        transition: "transform .3s ease-out",
                        WebkitTransition: "-webkit-transform .3s ease-out",
                        willChange: "transform",
                        overflowY: "auto"
                    },
                    overlay: {
                        zIndex: 19,
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        opacity: 0,
                        visibility: "hidden",
                        transition: "opacity .3s ease-out, visibility .3s ease-out",
                        backgroundColor: "rgba(0,0,0,.3)"
                    },
                    dragHandle: {
                        zIndex: 11,
                        position: "fixed",
                        top: 0,
                        bottom: 0
                    }
                }}
            >
                <></> {/*do not remove this*/}
            </Sidebar>
        );
    }
}

const mapStateToProps = function (state) {
    const designers = state.appReducer.init ? state.appReducer.init.designers : [];
    const stores = state.appReducer.init ? state.appReducer.init.stores : [];
    const bc_filter_tree = state.appReducer.bc_filter_tree ? state.appReducer.bc_filter_tree : [];
    return {designers, stores, bc_filter_tree};
};

export default connect(mapStateToProps, null)(SidebarMenu);